<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <!-- <ul>
                <li><a routerLink="/">Accueil</a></li>
                <li>Bienvenue</li>
            </ul> -->
            <h2 style="color:white">L'école s'inspire du texte de Actes 19: 8 -10       
            </h2>
            <h5 style="font-size:16px !important;color:white">
                « 8. Ensuite Paul entra dans la synagogue, où il parla librement. Pendant trois mois, il discourut sur les choses qui concernent le royaume de Dieu, s'efforçant de persuader ceux qui l'écoutaient.
                9. Mais, comme quelques-uns restaient endurcis et incrédules, décriant devant la multitude la voie du Seigneur, il se retira d'eux, sépara les disciples, et enseigna chaque jour dans l'école d'un nommé Tyrannus.
                10. Cela dura deux ans, de sorte que tous ceux qui habitaient l'Asie, Juifs et Grecs, entendirent la parole du Seigneur ». 
                
            </h5>
        </div>
    </div>
    <div class="shape9"><img src="assets/img/shape8.svg" alt="image"></div>
</div>

<div class=" asset profile-authentication-area ptb-100">
    <div class="container">
        <div class="row">

            <div class="col-lg-6 col-md-12" style="margin-bottom:12px">
                <img src="assets/img/insc.jpg">
            </div>
            <div class="col-lg-6 col-md-12">
                <div class="login-form">
                    <h2>Je crée mon compte</h2>
                    <form [formGroup]="signUpForm" ngNativeValidate (ngSubmit)="onSubmit()">
                        <div class="form-group">
                            <label>Adresse Email</label>
                            <input required formControlName="email" name="email1" type="text" class="form-control">
                        </div>
                        <div formGroupName="matching_password">
                            <div class="form-group">
                                <label>Choisissez un mot de passe</label>
                                <input autocomplete="on" required formControlName="password" name="password1"
                                    type="password" class="form-control">
                            </div>

                            <div class="form-group">
                                <label>Confirmez votre mot de passe</label>
                                <input autocomplete="on" required formControlName="confimpassword"
                                    name="confirmpassword" type="password" class="form-control">
                            </div>
                            <div *ngIf="message" style="color:red;margin-top: -20px !important;
                            margin-bottom: 20px">
                                {{message}}
                            </div>
                        </div>
                        <div class="form-group">
                            <label>Code d'activation</label>
                            <input required autocomplete="on" required formControlName="enableCode" name="code"
                                type="text" class="form-control">
                        </div>

                        <div class="row" style="margin-bottom:20px">

                            <div class="col-lg-6 col-md-6 col-sm-6">
                                <a routerLink="/login" class="lost-your-password">S'identifier</a>
                            </div>
                        </div>


                        En cliquant sur S’inscrire, vous acceptez nos Conditions générales. Découvrez comment nous
                        recueillons, utilisons vos données en lisant notre Politique d’utilisation des données et
                        comment nous utilisons les cookies et autres technologies similaires.
                        <!-- [disabled]="!loginTeacherForm.valid" [disabled]="loginTeacherForm.invalid" -->
                        <button [disabled]="showSpinner" type="submit" class="btn btn-success" type="submit">S'inscrire<span *ngIf="showSpinner"
                                class="spinner-border spinner"></span></button>


                    </form>
                </div>
            </div>
        </div>
    </div>
</div>